import { Hospital } from '../../models/Hospital.model'
import { USStates } from '../../models/USStates.model'

export type HospitalEditDraft = {
  name: string
  address: string
  city: string
  state: USStates | ''
  zip: string
  website: string
  supportTelephone: string
  supportEmail: string
  image: string | null
}

const EMPTY_CONTACT_VALUES = new Set(['', 'n/a', 'na', 'not available', 'none', 'null', 'undefined'])

export const normalizeEditableField = (value?: string | null): string => {
  if (!value) return ''
  const trimmed = value.trim()
  if (EMPTY_CONTACT_VALUES.has(trimmed.toLowerCase())) return ''
  return trimmed
}

export const hospitalToEditDraft = (hospital: Hospital): HospitalEditDraft => ({
  address: normalizeEditableField(hospital.address),
  city: normalizeEditableField(hospital.city),
  image: hospital.image,
  name: hospital.name,
  state: hospital.state.code || '',
  supportEmail: normalizeEditableField(hospital.supportEmail),
  supportTelephone: normalizeEditableField(hospital.supportTelephone),
  website: normalizeEditableField(hospital.website),
  zip: normalizeEditableField(hospital.zip),
})

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const sanitizePhoneInput = (value: string): string => value.replace(/[^\d+().\-\s]/g, '')

export const isValidSupportEmail = (value: string): boolean => {
  const trimmed = value.trim()
  if (!trimmed) return true
  return EMAIL_PATTERN.test(trimmed)
}
